var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Practice/PracticeInvitation/index.tsx";
import React, { useState } from 'react';
import { Divider, HStack, IconValidationValid, Stack, Text, VStack } from '@adc/parallax-component-library';
import { PracticeErrorCode } from 'Enums';
import { useApiError, useLibrePractice, useToast } from 'Hooks';
import { Button, Footer, Form, Main, RichText, ScrollContainer, Spinner, TitleActionBar } from 'Components/utility';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import { applyPhoneNumberMask, getDocumentPathFromLanguage } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const PracticeInvitation = ({
  data: {
    practiceInvitation
  }
}) => {
  const [loading, setLoading] = useState(false);
  const {
    acceptOrRejectPracticeInvitation
  } = useLibrePractice();
  const {
    showApiErrorModal
  } = useApiError();
  const {
    showToast
  } = useToast();
  const onPrivacyNoticeLinkClick = () => {
    const {
      documentsUrl,
      documents
    } = store.getState().config;
    const {
      language
    } = store.getState().lang;
    const privacyNoticePath = getDocumentPathFromLanguage(documents?.privacypolicy, language);
    if (privacyNoticePath) {
      const privacyNoticeFullUrl = `${documentsUrl}${privacyNoticePath}`;
      window.open(privacyNoticeFullUrl, '_blank');
    }
  };
  const handleAccept = async () => {
    if (!practiceInvitation) {
      return;
    }
    setLoading(true);
    const resp = await acceptOrRejectPracticeInvitation(practiceInvitation.invitationId, 'accept');
    setLoading(false);
    if (!resp.errorCode && resp.practiceConnection) {
      showToast({
        message: i18n.t('Connections.modals.practiceAddedToast.body'),
        'aria-label': i18n.t('Connections.modals.practiceAddedToast.body'),
        icon: /*#__PURE__*/React.createElement(IconValidationValid, {
          color: "$support.positive.default",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75,
            columnNumber: 15
          }
        })
      });
      mediator.publish('router:navigate', {
        url: '/lv-practice-connection',
        data: {
          practiceConnection: resp.practiceConnection
        }
      });
      return;
    }
    if (resp.errorCode === PracticeErrorCode.TOO_MANY_CONNECTIONS) {
      store.dispatch({
        type: SHOW_MODAL,
        modalProps: {
          details: i18n.t('Connections.modals.maxPracticesError.body'),
          testID: 'TooManyConnections'
        }
      });
      return;
    }
    showApiErrorModal();
  };
  const handleDecline = async () => {
    if (!practiceInvitation) {
      return;
    }
    setLoading(true);
    const resp = await acceptOrRejectPracticeInvitation(practiceInvitation.invitationId, 'decline');
    setLoading(false);
    if (!resp.errorCode) {
      showToast({
        message: i18n.t('Connections.modals.practiceRemovedToast.body'),
        'aria-label': i18n.t('Connections.modals.practiceRemovedToast.body'),
        icon: undefined
      });
      mediator.publish('router:navigate', '/connections');
      return;
    }
    showApiErrorModal();
  };
  const onDeclineBtnClick = () => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Connections.modals.declineInvitationDialog.body'),
        testID: 'DeclineInvitation',
        primaryAction: {
          label: i18n.t('Global.microcopy.common.yes'),
          onPress: () => {
            handleDecline();
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.no'),
          onPress: () => store.dispatch({
            type: CLOSE_MODAL
          })
        }
      }
    });
  };
  if (!practiceInvitation) {
    mediator.publish('router:navigate', '/connections');
    return null;
  }
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 5
    }
  }, loading && /*#__PURE__*/React.createElement(Spinner, {
    "aria-label": "Loading",
    testID: "PendingPracticeInvitation.spinner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 154,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "PendingPracticeInvitation",
    title: i18n.t('Connections.content.pendingInvitation.primaryText'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    marginTop: 0,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 160,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "PendingPracticeInvitation.secondaryText",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    color: "$text.100",
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 161,
      columnNumber: 11
    }
  }, i18n.t('Connections.content.pendingInvitation.secondaryText')), /*#__PURE__*/React.createElement(Stack, {
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "PendingPracticeInvitation.practiceName",
    color: "$text.100",
    fontSize: "$h4.medium",
    fontWeight: "$bodyBase.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 171,
      columnNumber: 13
    }
  }, practiceInvitation.name), /*#__PURE__*/React.createElement(VStack, {
    marginTop: "$6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "PendingPracticeInvitation.practiceID.label",
    color: "$text.60",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    marginBottom: "$0.5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 180,
      columnNumber: 15
    }
  }, i18n.t('Connections.content.pendingInvitation.formField.practiceID.label')), /*#__PURE__*/React.createElement(Text, {
    testID: "PendingPracticeInvitation.practiceID",
    color: "$text.100",
    fontSize: "$bodyBase.medium",
    fontWeight: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 189,
      columnNumber: 15
    }
  }, practiceInvitation.businessId), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 197,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "PendingPracticeInvitation.practiceAddress.label",
    color: "$text.60",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    marginBottom: "$0.5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 198,
      columnNumber: 15
    }
  }, i18n.t('Connections.content.pendingInvitation.formField.practiceAddress.label')), /*#__PURE__*/React.createElement(Text, {
    testID: "PendingPracticeInvitation.practiceAddress",
    color: "$text.100",
    fontSize: "$bodyBase.medium",
    fontWeight: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 207,
      columnNumber: 15
    }
  }, `${practiceInvitation.address1}, ${practiceInvitation.city}, ${practiceInvitation.state} ${practiceInvitation.zip}`), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 215,
      columnNumber: 15
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "PendingPracticeInvitation.practicePhoneNumber.label",
    color: "$text.60",
    fontSize: "$bodySmall.default",
    fontWeight: "$bodySmall.default",
    marginBottom: "$0.5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 216,
      columnNumber: 15
    }
  }, i18n.t('Connections.content.pendingInvitation.formField.practicePhoneNumber.label')), /*#__PURE__*/React.createElement(Text, {
    testID: "PendingPracticeInvitation.practicePhoneNumber",
    color: "$text.100",
    fontSize: "$bodyBase.medium",
    fontWeight: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 227,
      columnNumber: 15
    }
  }, applyPhoneNumberMask(practiceInvitation.phoneNumber)))))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: "",
    customProps: /*#__PURE__*/React.createElement(Stack, {
      padding: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 242,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(RichText, {
      text: i18n.t('Connections.content.pendingInvitation.bodyText'),
      color: "$text.60",
      testID: "PendingPracticeInvitation.bodyText",
      onPressLink: onPrivacyNoticeLinkClick,
      fontToken: "$labelBase.default",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 243,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(HStack, {
      marginTop: "$4",
      justifyContent: "space-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 250,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Button, {
      testID: "PendingPracticeInvitation.declineBtn",
      padding: "$4",
      marginRight: "$4",
      flexGrow: 1,
      onPress: onDeclineBtnClick,
      variant: "secondary",
      label: i18n.t('Global.microcopy.common.decline'),
      "aria-label": i18n.t('Global.microcopy.common.decline'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 251,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(Button, {
      testID: "PendingPracticeInvitation.acceptBtn",
      flexGrow: 1,
      onPress: handleAccept,
      label: i18n.t('Global.microcopy.common.accept'),
      "aria-label": i18n.t('Global.microcopy.common.accept'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 261,
        columnNumber: 15
      }
    }))),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 239,
      columnNumber: 7
    }
  }));
};
export default PracticeInvitation;